module.exports = __webpack_public_path__ + "assets/images/e67de52c7f7b7dbb850c0d11d3c83d40.png";